import {
    post
  } from '@/utils/ajax.js'
  import Vue from 'vue'
import { changeLogins } from '../api'
  export default {
    state: {
      cartData:[],
      userInfo:{},
      userVisble:true,
      },
    actions: {
    
  
    },
    mutations: {
        submitcart (state, data) {
            if(state.cartData.find(item=>item.id===data.id)){
          console.log(state.cartData,data)
                console.log("已经存在")
                return 
            }else{
                console.log("目前还没有")
                state.cartData = state.cartData.concat(data)
            }
          },
          addcart (state, data) { //购物车中添加
            let arr = state.cartData
            console.log(data)
            let num =  arr.find(item=>item.id===data.id)
            num.amount ++ 
            state.cartData = arr
            },
          reducecart (state, data) { //购物车中减少
                let arr = state.cartData
                console.log(data)
                let num =  arr.find(item=>item.id===data.id)
                num.amount--
                state.cartData = arr
                },
            resetcart (state, data) { //购物车提交 后重置
                if(data){
                    state.cartData = data
                }
                
                 },
              setUserInfo(state,data){
                    state.userInfo = data
                 },
                 changeUserVisble(state,data){
                  console.log(state,data,"推送数据")
                    state.userVisble = data
                 }
                

    },
 
  
  }
  


// WEBPACK FOOTER //
// ./src/store/cart.js